/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Open_Floating_ExplorerInputs */



/**
* | output |
* | --- |
* | "Open floating explorer" |
*
* @param {Spaces_Open_Floating_ExplorerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_open_floating_explorer = /** @type {((inputs?: Spaces_Open_Floating_ExplorerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Open_Floating_ExplorerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schwebenden Explorer öffnen")
	return /** @type {LocalizedString} */ ("Open floating explorer")
});